import { PatientSelectorTheme, PatientSelectorModalTheme } from "./types";

export const defaultSelectorTheme: PatientSelectorTheme = {
  container:
    "flex flex-row gap-4 justify-start items-center p-0 w-full flex-wrap",
  patientItem:
    "flex flex-col items-center justify-center cursor-pointer gap-1 p-0 transition-all duration-200",
  avatar: {
    container: "relative w-11 h-11 flex items-center justify-center",
    selection:
      "absolute w-12 h-12 -top-0.5 -left-0.5 z-0 transition-opacity duration-200",
    image: "w-11 h-11 rounded-full z-10 object-cover",
  },
  label:
    "text-sm font-semibold leading-5 text-current mt-1 text-center transition-opacity duration-200",
  chevron: "w-6 h-6 text-current ml-auto flex-shrink-0",
  selected: {
    label: "opacity-100",
    selection: "opacity-100",
  },
  unselected: {
    label: "opacity-60",
    selection: "opacity-0",
  },
};

export const listLayoutTheme: PatientSelectorTheme = {
  container: "flex flex-col gap-3 w-full",
  patientItem:
    "flex flex-row items-center justify-start cursor-pointer gap-4 p-4 transition-all duration-200 w-full rounded-xl",
  avatar: {
    container: "w-12 h-12 flex items-center justify-center flex-shrink-0",
    image: "w-12 h-12 rounded-full object-cover",
  },
  label: "text-lg font-medium leading-6 text-current text-left flex-1",
  chevron: "w-6 h-6 text-current flex-shrink-0",
  selected: {
    item: "bg-white/10",
  },
  unselected: {
    item: "bg-transparent",
  },
};

export const defaultModalTheme: PatientSelectorModalTheme = {
  overlay:
    "fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4",
  modal:
    "bg-white rounded-xl w-full max-w-[400px] max-h-[90vh] overflow-hidden shadow-xl flex flex-col",
  header: "px-6 pt-6 pb-0",
  title: "text-xl font-semibold leading-7 text-gray-900 mb-1",
  subtitle: "text-sm font-normal leading-5 text-gray-500",
  body: "p-6 flex-1 overflow-y-auto",
  footer: "p-6 flex flex-col gap-2",
};
